(() => {
  const selector = '[data-smaxup-court-root]';

  function safePlay(video) {
    const promise = video.play();
    if (promise && typeof promise.catch === 'function') promise.catch(() => {});
  }

  function sync(root, video) {
    const play = root.querySelector('[data-smaxup-court-play]');
    const sound = root.querySelector('[data-smaxup-court-sound]');
    if (play) {
      const paused = video.paused;
      play.setAttribute('aria-label', paused ? 'Play video' : 'Pause video');
      play.classList.toggle('is-paused', paused);
    }
    if (sound) {
      sound.setAttribute('aria-pressed', String(!video.muted));
      sound.setAttribute('aria-label', video.muted ? 'Turn sound on' : 'Mute video');
      sound.classList.toggle('is-audible', !video.muted);
    }
  }

  function init(root) {
    if (root.dataset.smaxupCourtInitialized === 'true') return;
    const video = root.querySelector('.smaxup-court__video');
    if (!video) return;
    root.dataset.smaxupCourtInitialized = 'true';
    video.muted = true;
    video.defaultMuted = true;
    video.playsInline = true;

    root.querySelector('[data-smaxup-court-play]')?.addEventListener('click', () => {
      if (video.paused) safePlay(video); else video.pause();
      sync(root, video);
    });
    root.querySelector('[data-smaxup-court-sound]')?.addEventListener('click', () => {
      video.muted = !video.muted;
      if (video.paused) safePlay(video);
      sync(root, video);
    });
    ['play', 'pause', 'volumechange', 'ended'].forEach(event => video.addEventListener(event, () => sync(root, video)));
    sync(root, video);

    if (root.dataset.autoplay !== 'true' || matchMedia('(prefers-reduced-motion: reduce)').matches || !('IntersectionObserver' in window)) return;
    const observer = new IntersectionObserver(entries => {
      entries.forEach(entry => {
        if (entry.isIntersecting) safePlay(video);
        else {
          video.pause();
          video.muted = true;
          sync(root, video);
        }
      });
    }, { rootMargin: '120px 0px', threshold: 0.05 });
    observer.observe(video);
  }

  function initAll(scope = document) {
    scope.querySelectorAll(selector).forEach(init);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => initAll());
  else initAll();
  document.addEventListener('shopify:section:load', event => initAll(event.target));
})();
